import {
	type CaptchaChallengeV2Get,
	disableNotificationInterceptors,
	type FetchCaptchaChallengeV2ParamsAppType,
	type PostUserLoginEmailEmailGenerateCodePayload,
	type PostUserLoginEmailGenerateCodePayload,
	type PostUserLoginEmailPayload,
	type PostUserLoginEmailWhatsappGenerateCodePayload,
	type PostUserLoginMobileGenerateCodeV2Payload,
	type PostUserLoginWhatsappGenerateCodePayload,
	type UserEmailLoginEmailGenerateCodePost,
	type UserLoginEmailGenerateCodeV2Post,
	type UserLoginMobileGenerateCodeV2Post,
	type UserLoginMobilePost
} from '@capsicum/common';
import { match } from 'ts-pattern';

import { captchaApi, loginApi } from '.';

import type { FullGenerateCodeParams, GeetestChallengeMetadata, SmsLoginParams } from '../../models';

export const postLoginMobile = async (loginParams: SmsLoginParams): Promise<Required<UserLoginMobilePost>> => {
	const api = await loginApi;
	const response = await api.postUserLoginMobile(loginParams, {
		customErrorInterceptor: disableNotificationInterceptors
	});

	return response.data as Required<UserLoginMobilePost>;
};

export const postLoginEmail = async (
	loginParams: PostUserLoginEmailPayload
): Promise<Required<UserLoginMobilePost>> => {
	const api = await loginApi;
	const response = await api.postUserLoginEmail(loginParams, {
		customErrorInterceptor: disableNotificationInterceptors
	});

	return response.data as Required<UserLoginMobilePost>;
};

export const postMobileGenerateCode = async (
	mobileNumberValidationParams: FullGenerateCodeParams
): Promise<UserLoginMobileGenerateCodeV2Post> => {
	const api = await loginApi;

	const response = await api.postUserLoginMobileGenerateCodeV2(
		mobileNumberValidationParams as PostUserLoginMobileGenerateCodeV2Payload
	);

	return response.data as UserLoginMobileGenerateCodeV2Post;
};

export const postEmailGenerateCodeByMobileNumber = async (
	emailValidationParams: PostUserLoginEmailGenerateCodePayload
): Promise<UserLoginEmailGenerateCodeV2Post> => {
	const api = await loginApi;

	const response = await api.postUserLoginEmailGenerateCode(emailValidationParams);

	return response.data as UserLoginEmailGenerateCodeV2Post;
};

export const postEmailGenerateCode = async (
	params: PostUserLoginEmailEmailGenerateCodePayload
): Promise<UserEmailLoginEmailGenerateCodePost> => {
	const api = await loginApi;

	const response = await api.postUserLoginEmailEmailGenerateCode(params);

	return response.data as UserEmailLoginEmailGenerateCodePost;
};

export const postGenerateWhatsappCodeByEmail = async (
	params: PostUserLoginEmailWhatsappGenerateCodePayload
): Promise<UserEmailLoginEmailGenerateCodePost> => {
	const api = await loginApi;

	const response = await api.postUserLoginEmailWhatsappGenerateCode(params);

	return response.data as UserEmailLoginEmailGenerateCodePost;
};

export const postGenerateWhatsappCodeByMobileNumber = async (
	params: PostUserLoginWhatsappGenerateCodePayload
): Promise<UserLoginEmailGenerateCodeV2Post> => {
	const api = await loginApi;

	const response = await api.postUserLoginWhatsappGenerateCode(params);

	return response.data as UserLoginEmailGenerateCodeV2Post;
};

export const getGeetestChallenge = async (
	appType: FetchCaptchaChallengeV2ParamsAppType,
	metadata?: GeetestChallengeMetadata
): Promise<Required<CaptchaChallengeV2Get>> => {
	const api = await captchaApi;

	const commonPayload = {
		appContext: 'capsicum' as const,
		appType
	};

	const response = await api.fetchCaptchaChallengeV2(
		match(metadata && metadata.type)
			.with('phone-number', () => ({
				...commonPayload,
				...(!metadata ? {} : metadata!.details)
			}))
			.otherwise(() => commonPayload)
	);

	return response.data as Required<CaptchaChallengeV2Get>;
};
